import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UI_Header from '../components/UI_Header';
import UI_Ribbon_Main from '../components/UI_Ribbon_Main';
import UI_NavigationRail from '../components/ERUMAUI/UI_NavigationRail';
import ContextProviderAccountManagementSelectedAccount from '../Contexts/Context_AccountManagement_SelectedAccount';
import ContextProviderAccountManagementRefreshList from '../Contexts/Context_AccountManagement_RefreshList';
import { useAccounts } from '../Contexts/Context_Accounts';
import { useProperties } from '../Contexts/Context_App_Properties';
import { useAuth } from '../Contexts/AuthContext';
import { useTemplating } from '../Contexts/Context_Templating';
import UI_Subwindows from '../components/UI_Subwindows';
import { Context_UI } from '../Contexts/Context_UI';
import Context_Provider_Templating from '../Contexts/Context_Templating';
import Context_Provider_Accounts from '../Contexts/Context_Accounts';
import Context_Provider_MapRenderer from '../Contexts/Context_MapRenderer';
import Context_Provider_ScheduleManagement from '../Contexts/Context_ScheduleManagement';
import { useStatus } from '../Contexts/Context_Status_Global';

import Panel_Map_Left from '../components/InteractiveMap/Panel_Map_Left';
import Panel_Home_Center from '../components/Home/Panel_Home_Center';
import Panel_Home_Right from '../components/Home/Panel_Home_Right';
import Panel_AccountManagement_Center from '../components/AccountManagement/Panel_AccountManagement_Center';
import Panel_AccountManagement_Right from '../components/AccountManagement/Panel_AccountManagement_Right';
import Panel_Map_Center from '../components/InteractiveMap/Panel_Map_Center';
import Panel_Map_Right from '../components/InteractiveMap/Panel_Map_Right';
import Panel_Templating_Center from '../components/Templating/Panel_Templating_Center';
import Panel_ScheduleManagement_Center from '../components/ScheduleManagement/Panel_ScheduleManagement_Center';
import Panel_ScheduleManagement_Right from '../components/ScheduleManagement/Panel_ScheduleManagement_Right';
import Panel_Reporting_Center from '../components/Reporting/Panel_Reporting_Center';

import UI_Slide_Manager from '../components/ERUMAUI/UI_Slide_Manager';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import UI_Icon from '../components/ERUMAUI/UI_Icons';

import Icon_Home from '../Assets/Icons/Icon_Home.png';
import Icon_Map from '../Assets/Icons/Icon_Map.png';
import Icon_Clock from '../Assets/Icons/Icon_Clock.png';
import Icon_Reports from '../Assets/Icons/Icon_Reports.png';
import Icon_User from '../Assets/Icons/Icon_User.png';
import Icon_Template from '../Assets/Icons/Icon_Template.png';
import Icon_Edit from '../Assets/Icons/Icon_Edit.png';
import Icon_Save from '../Assets/Icons/Icon_Save.png';
import Icon_Requests from '../Assets/Icons/Icon_Requests.png';

import Subwindow_Modal_Register_RequestSent from '../components/Subwindow_Modal_Register_RequestSent';
import Subwindow_Templating_EditBlockedHours from '../components/Templating/Subwindow_Templating_EditBlockedHours';
import Subwindow_Modal_UnsavedChanges from '../components/Subwindow_Modal_UnsavedChanges';
import Subwindow_ScheduleManagement_Reserve from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Reserve';
import Subwindow_ScheduleManagement_Attendees from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Attendees';
import Subwindow_ScheduleManagement_Equipment from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Equipment';
import Subwindow_ScheduleManagement_Map from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Map';
import Subwindow_ScheduleManagement_Reservation_Success from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Reservation_Success';
import Subwindow_ScheduleManagement_Document from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Document';
import Subwindow_ScheduleManagement_Conflict_Resolve_Standard from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Conflict_Resolve_Standard';
import Subwindow_Map_ChooseRoom from '../components/InteractiveMap/Subwindow_Map_ChooseRoom';


export default function DR_Main() {
    const UI = useContext(Context_UI);
    const navigate = useNavigate();
    const location = useLocation();
    const { Slide_Switch } = useStatus();
    const { Account, Loading, Logout } = useAuth();
    const { Templates_Edit_Save_Attempt, Template_Editor_Unsaved } = useTemplating();

    useEffect(() => {
        console.log("Loadingscreen hiding");
        UI.Page_Navigator_Set(navigate);
        // UI.Initialize();
        UI.LoadingScreen_Hide("Screen_Loading");
    }, []);

    useEffect(() => {
        // console.log(Account?.Access.Reservation.Create);
    }, [location.pathname]);

    // Match Slide_ID with a slide property on App_Properties.
    const [Composition_Slide, Composition_Slide_Set] = useState([]);
    const [Template_Save, Template_Save_Set] = useState({ State: false });
    useEffect(() => {
        // console.log(Template_Editor_Unsaved);
        if (Template_Editor_Unsaved) {
            Template_Save_Set({ State: true });
        } else {
            Template_Save_Set({ State: false });
        }
    }, [Template_Editor_Unsaved]);

    const User_canManage = Account?.Access.Reservation.Edit || Account?.Access.Reservation.Approve.Initial || Account?.Access.Reservation.Approve.Final

    useEffect(() => {

        Composition_Slide_Set([
            {
                Slide_ID: "Home",
                Panel_Left: null,
                Panel_Center: <Panel_Home_Center />,
                Panel_Right: <Panel_Home_Right />,
                Active: () => true,
                Ribbon: {
                    Active: () => false,
                    Contents: []
                }
            },
            {
                Slide_ID: "Map",
                Panel_Left: <Panel_Map_Left />,
                Panel_Center: <Panel_Map_Center />,
                Panel_Right: <Panel_Map_Right />,
                Active: () => Account?.Access.InteractiveMap.View,
                Ribbon: {
                    Active: () => true,
                    Contents: [
                        {
                            Icon: Icon_Edit,
                            Text: "Map Editor",
                            Destination: "/map/edit",
                            Action: null,
                            Active: () => Account?.Access.InteractiveMap.Edit
                        }
                    ]
                }
            },
            {
                Slide_ID: "Schedule",
                Panel_Left: null,
                Panel_Center: <Panel_ScheduleManagement_Center />,
                Panel_Right: <Panel_ScheduleManagement_Right />,
                Active: () => Account?.Access.Schedules.View,
                Ribbon: {
                    Active: () => true,
                    Contents: [
                        {
                            Icon: Icon_Edit,
                            Text: "Create a reservation",
                            Destination: "/schedules/reserve",
                            Action: null,
                            Active: () => Account?.Access.Reservation.Create
                        },
                        {
                            Icon: Icon_Requests,
                            Text: "Manage requests",
                            Destination: "/schedules/manage",
                            Action: null,
                            Active: () => true
                        }
                    ]
                }
            },
            {
                Slide_ID: "Reports",
                Panel_Left: null,
                Panel_Center: <Panel_Reporting_Center />,
                Panel_Right: null,
                // Active: () => Account?.Access.Reports.View,
                Active: () => true,
                Ribbon: {
                    Active: () => false,
                    Contents: [
                        {
                            Icon: Icon_Edit,
                            Text: "Create a reservation",
                            Destination: "/schedules/reserve",
                            Action: null,
                            Active: () => Account?.Access.Reservation.Create
                        }
                    ]
                }
            },
            {
                Slide_ID: "Accounts",
                Panel_Left: null,
                Panel_Center: <Panel_AccountManagement_Center />,
                Panel_Right: <Panel_AccountManagement_Right />,
                Active: () => Account?.Access.Account.Manage_Others,
                Ribbon: {
                    Active: () => false,
                    Contents: []
                }
            },
            {
                Slide_ID: "Templating",
                Panel_Left: null,
                Panel_Center: <Panel_Templating_Center />,
                Panel_Right: null,
                Active: () => Account?.Access.Templating.View,
                Ribbon: {
                    Active: () => false,
                    Contents: [
                        {
                            Icon: Icon_Save,
                            Text: "Save changes",
                            Destination: null,
                            Action: () => Templates_Edit_Save_Attempt(),
                            Active: () => true
                        }
                    ]
                }
            }
        ]);
    }, [Template_Editor_Unsaved, location.pathname, Account]);


    // Applies to the entire page
    const [Composition_Navigation, Composition_Navigation_Set] = useState([]);

    useEffect(() => {
        Composition_Navigation_Set([
            {
                Routes: ["/", "/home"],
                Destination: "/home",
                Icon: Icon_Home,
                Text: "Home",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            },
            {
                Routes: ["/map", "/map/view"],
                Destination: "/map",
                Icon: Icon_Map,
                Text: "Interactive Map",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access.InteractiveMap.View
            },
            {
                Routes: ["/schedules"],
                Destination: "/schedules",
                Icon: Icon_Clock,
                Text: "Schedules",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access.Schedules.View
            },
            {
                Routes: ["/reports"],
                Destination: "/reports",
                Icon: Icon_Reports,
                Text: "Reports",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access.Report.View
            },
            {
                Routes: ["/accounts"],
                Destination: "/accounts",
                Icon: Icon_User,
                Text: "Accounts Management",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access.Account.Manage_Others
            },
            {
                Routes: ["/templating"],
                Destination: "/templating",
                Icon: Icon_Template,
                Text: "System Templating",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access.Templating.View
            }
        ])
    }, [Account]);

    // Define all the subwindows the page's slides use
    const [Composition_Subwindow, Composition_Subwindow_Set] = useState([
        {
            ID: "Window_General_UnsavedChanges",
            Component: <Subwindow_Modal_UnsavedChanges />
        },
        {
            ID: "Window_Register_Success",
            Component: <Subwindow_Modal_Register_RequestSent />
        },
        {
            ID: "Window_Templating_EditBlockedHours",
            Component: <Subwindow_Templating_EditBlockedHours />
        },
        {
            ID: "Window_ScheduleManagement_Reserve",
            Component: <Subwindow_ScheduleManagement_Reserve />
        },
        {
            ID: "Window_ScheduleManagement_Conflict_Resolve_Standard",
            Component: <Subwindow_ScheduleManagement_Conflict_Resolve_Standard />
        },
        {
            ID: "Window_ScheduleManagement_Attendees",
            Component: <Subwindow_ScheduleManagement_Attendees />
        },
        {
            ID: "Window_ScheduleManagement_Equipment",
            Component: <Subwindow_ScheduleManagement_Equipment />
        },
        {
            ID: "Window_ScheduleManagement_Map",
            Component: <Subwindow_ScheduleManagement_Map />
        },
        {
            ID: "Window_ScheduleManagement_Reserve_Success",
            Component: <Subwindow_ScheduleManagement_Reservation_Success />
        },
        {
            ID: "Window_ScheduleManagement_Document",
            Component: <Subwindow_ScheduleManagement_Document />
        },
        {
            ID: "Window_Map_ChooseRoom",
            Component: <Subwindow_Map_ChooseRoom/>
        }
    ]);

    return (

        <ui-main>
            <UI_Subwindow_Manager Composition={Composition_Subwindow} />
            <UI_Header />
            <UI_NavigationRail Composition={Composition_Navigation} />
            <ContextProviderAccountManagementSelectedAccount>
                <ContextProviderAccountManagementRefreshList>
                    <UI_Slide_Manager Composition={Composition_Slide} />
                </ContextProviderAccountManagementRefreshList>
            </ContextProviderAccountManagementSelectedAccount>
        </ui-main>



    )
}